Auth = require 'db/auth'
Backbone = require 'backbone'
ClientVersion = require 'debug/client-version'
Monitor = require 'lib/monitor'
Socket = require 'network/socket'
Storage = require 'lib/storage'
Util = require 'lib/util'
_ = require 'underscore'
log = require 'debug/log'
track = require 'debug/track'

module.exports = class SocketRPC
  _.extend @prototype, Backbone.Events

  constructor: (@delegate) ->
    @reqid = 0
    @dictCallback = {}
    @dictTime = {}
    @connectedOnce = false
    @modelIxUpdate = {}

    @hasSockets = 'WebSocket' of window &&
                  Storage.get('useWebsockets') != 'no'

    if 'WebSocket' !of window
      track("RPC", "No Sockets", "No WebSocket")
    else if Storage.get('useWebsockets') == 'no'
      track("RPC", "No Sockets", 'pitStop')

    if !@hasSockets
      return

    log('rpc', "opening newSocket")
    protocol = if document.location.protocol == 'http:' then 'ws:' else 'wss:'
    @socket = new Socket "#{protocol}//#{document.location.host}/1/Session/socket?token=#{Auth.myToken()}",
      maxReconnectDelay: 64000
      failedConsecutiveReconnectsLimit: 10
      reconnectRateLimit: 3
      reconnectRateWindow: Util.getMs(minutes: 5)
      maxReconnectsPerDay: 100
      fxReconnectDelay: (event) ->
        status = Monitor.getStatus()
        slowMs =
          if status == 'active'
            Util.randomWait(Util.getMs(seconds: 10), Util.getMs(seconds: 30))
          else
            Util.randomWait(Util.getMs(seconds: 30), Util.getMs(minutes: 2))
        fastMs =
          if status == 'active'
            Util.randomWait(100, Util.getMs(seconds: 1))
          else
            Util.randomWait(Util.getMs(seconds: 2), Util.getMs(seconds: 10))

        if !event? || event.code == 1006
          # We caused the disconnection or a hard crash of the proc, respectively
          # Let's take it slow
          slowMs
        else if event.code == 4000
          try
            seconds = parseInt(event.reason, 0)
          catch
            fastMs
          if status == 'active'
            Util.randomWait(Util.getMs({ seconds }), Util.getMs({ seconds }) * 4)
          else
            Util.randomWait(Util.getMs({ seconds }) * 4, Util.getMs({ seconds }) * 4 * 4)
        else
          fastMs

    for sEv in ['connect', 'reconnect', 'connecting', 'reconnecting', 'disconnect', 'connect_failed', 'reconnect_failed', 'error']
      do (sEv) =>
        @socket.on sEv, (info) =>
          log('rpc', "socket event", sEv, info)

    for sEv in ['connecting', 'reconnecting']
      do (sEv) =>
        @socket.on sEv, =>
          log('rpc', "connecting")
          @trigger('connecting')

    @socket.on 'connect_failed', =>
      log('rpc', 'connect_failed')
      @trigger('connect_failed')

    @socket.on 'reconnect_failed', =>
      log('rpc', 'reconnect_failed')
      @trigger('reconnect_failed')

      return unless @socket.reconnectNotAttemptedReason != @socket.previousReason

      timeSinceGoodConnection = Date.now() - (@dateLastMessage || 0)
      track('Error', 'Websocket Redbox', 'Time since good connection', undefined, timeSinceGoodConnection)
      track('Error', 'Websocket Redbox', 'Reconnect failure reason', @socket.reconnectNotAttemptedReason, undefined)

      log('rpc', 'time since last good connection', timeSinceGoodConnection)
      log('rpc', 'reconnect failure reason', @socket.reconnectNotAttemptedReason)

    @socket.on 'connect', =>
      log('rpc', "connect")
      @trigger('connect')
      @connectedOnce = true

    @socket.on 'reconnect', =>
      log('rpc', "reconnect")
      clearTimeout(@timeoutInvokeResponse)
      delete @timeoutInvokeResponse
      @trigger('reconnect')

    @socket.on 'disconnect', (reason) =>
      log('rpc', "disconnect", reason)
      clearTimeout(@timeoutInvokeResponse)
      delete @timeoutInvokeResponse
      _.each @dictCallback, (next) ->
        next?('disconnected')
      @dictCallback = {}
      @dictTime = {}

    @socket.on 'error', =>
      if @connectedOnce && !@socket?.socket?.connected
        @trigger('disconnect')

    @socket.on 'data', (msg) =>
      @_messageHandler(msg)

    return

  _messageHandler: (msg) ->
    @dateLastMessage = Date.now()
    log('rpc', "message", msg)

    #For timeout clear, we don't really care if it's the same one, just that the server is alive
    clearTimeout(@timeoutInvokeResponse)
    delete @timeoutInvokeResponse

    if msg?.version
      ClientVersion.setServerVersion(msg)
      return

    if msg.reqid?
      next = @dictCallback["fx#{msg.reqid}"]

    if msg.result?
      next?(null, msg.result)
    else if msg.notify?.event
      if msg.idModelChannel?
        @delegate.setIxLastUpdate(msg.idModelChannel, msg.ixLastUpdateChannel)
      @trigger(msg.notify.event, _.extend({ idModelChannel: msg.idModelChannel }, msg.notify))
    else if msg.error
      next?(msg.error)
    else
      log('rpc', "unrecognized message", msg)

    if msg.reqid?
      delta = (new Date()) - @dictTime[msg.reqid]
      log('timing', "message", msg.reqid, "time", delta)

      delete @dictCallback["fx#{msg.reqid}"]
      delete @dictTime[msg.reqid]
    return

  subscribe: (modelType, idModel, tags, next) ->
    @send {
      type: 'subscribe'
      modelType
      idModel
      tags
      invitationTokens: Util.invitationTokens()
    },  (err, ixLastUpdate) =>
      if err?
        log('rpc', err)
      else
        @delegate.setIxLastUpdate(idModel, ixLastUpdate)
      next?(err, ixLastUpdate)

  unsubscribe: (modelType, idModel, next) ->
    @send {
      type: 'unsubscribe'
      modelType
      idModel
    }, (err, response) =>
      if err?
        log('rpc', err)
      next?(err, response)

  ping: (next) ->
    @send {
      type: 'ping'
    }, (err, response) =>
      if err?
        log('rpc', err)
      next?(err, response)

  _getSubscriptions: ->
    # For debugging - thus logging only
    @send {
      type: 'getSubscriptions'
    }, (err, response) =>
      if response?
        log('rpc', response)

  send: (msg, next) ->
    @dictCallback["fx#{@reqid}"] = next
    @dictTime[@reqid] = new Date()
    msg.reqid = @reqid++

    sMsg = JSON.stringify(msg)

    log('rpc', "invoke: " + sMsg)
    @socket.send(sMsg)
    if !@timeoutInvokeResponse?
      @timeoutInvokeResponse = setTimeout =>
        if @socket.state != Socket.CONNECTED
          # The socket knows it isn't connected.
          return
        log('rpc', "No response from the socket.io server in 10 seconds. Disconnecting.")
        clearTimeout(@timeoutInvokeResponse)
        delete @timeoutInvokeResponse
        @socket?.disconnect()
      , 10000
    return

  resync: (idModels...) ->
    if _.isEmpty idModels
      idModels = null
    @delegate.rpcAJAX.doPoll(idModels, @, ->)

  disconnect: ->
    log('rpc', "disconnecting")
    @socket.disconnect()
    return

  destroy: ->
    @socket.destroy()

  hasSocketTransport: -> @hasSockets



// WEBPACK FOOTER //
// ./app/scripts/network/rpc/socket-rpc.coffee